"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var RecharglyButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/RecharglyButton"));
var Modal_1 = __importDefault(require("atomicComponents/organisms/Modal"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var SearchBar_1 = __importDefault(require("atomicComponents/organisms/SearchBar"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var hooks_1 = require("utils/hooks");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
// import ImportChargesByUrl from './ImportChargesByUrl';
var UploadInvoice_1 = __importDefault(require("../ModalComponents/UploadInvoice"));
var AddVendorModalContent_1 = __importDefault(require("./AddVendorModalContent"));
var AddVendorModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, props = __rest(_a, ["open", "onClose"]);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var _b = __read(react_1.default.useState(), 2), rechVendorId = _b[0], setRechVendorId = _b[1];
    var _c = __read(react_1.default.useState(false), 2), firstMailStepDone = _c[0], set1stMailStepDone = _c[1];
    var _d = __read(react_1.default.useState(), 2), emailProvider = _d[0], setEmailProvider = _d[1];
    var _e = __read(react_1.default.useState(''), 2), searchText = _e[0], setSearchText = _e[1];
    var goBack = function () {
        if (emailProvider) {
            return setEmailProvider(undefined);
        }
        if (firstMailStepDone) {
            return set1stMailStepDone(false);
        }
        return setRechVendorId(undefined);
    };
    var _f = __read((0, hooks_1.useSubmitter)('recharged_company_vendors', "".concat(rechVendorId, "-").concat(company === null || company === void 0 ? void 0 : company.id), { rechVendorId: rechVendorId, companyId: company === null || company === void 0 ? void 0 : company.id, isEnabled: true }), 2), createRel = _f[0], isCreating = _f[1];
    var rechVendors = (0, react_redux_1.useSelector)(ordered_1.selectNewRechargedVendors);
    var isOtherVendor = rechVendorId && rechVendorId !== 'Xero';
    var handleOnClose = function () {
        onClose();
        setRechVendorId(undefined);
    };
    var createVendorRel = function () { return rechVendorId && createRel().then(handleOnClose); };
    var handleSelectVendor = function (vendor) {
        setRechVendorId(vendor);
        setSearchText('');
    };
    if (!rechVendors) {
        return (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, {});
    }
    var selectedVendor = rechVendors.find(function (rV) { return rV.id === rechVendorId; });
    var getTitle = function () {
        if (!selectedVendor) {
            return 'Import charges from a new vendor';
        }
        if (selectedVendor.mainImportMethod === 'email') {
            if (emailProvider)
                return "Set up automatic forwarding of ".concat(selectedVendor.name, " Invoices for ").concat(emailProvider);
            if (firstMailStepDone)
                return 'What email provider are you using?';
            return "Send your latest ".concat(selectedVendor.name, " Invoice Email");
        }
        return "Upload your latest ".concat(selectedVendor.name, " invoice");
    };
    // ToDo: mix these things together better
    if ((selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.importMethodOnAdd) === 'upload') {
        return ((0, jsx_runtime_1.jsx)(UploadInvoice_1.default, { onClose: onClose, open: open, vendor: selectedVendor.name, onClickLater: createVendorRel, onClickBack: goBack }));
    }
    return ((0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({ open: open, onClose: onClose }, props, { label: "Add vendor modal", PaperProps: { sx: rechVendorId && (selectedVendor === null || selectedVendor === void 0 ? void 0 : selectedVendor.mainImportMethod) === 'email' ? { maxWidth: 760 } : undefined } }, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "space-between", pr: 4 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: getTitle() })), !selectedVendor && (0, jsx_runtime_1.jsx)(SearchBar_1.default, { searchText: searchText, setSearchText: setSearchText })] })) }), (0, jsx_runtime_1.jsx)(ModalContent_1.default, __assign({ minHeight: !rechVendorId ? 480 : 0, maxHeight: 480 }, { children: (0, jsx_runtime_1.jsx)(AddVendorModalContent_1.default, { emailProvider: emailProvider, setEmailProvider: setEmailProvider, handleSelectVendor: handleSelectVendor, searchText: searchText, selectedVendor: selectedVendor, firstMailStepDone: firstMailStepDone, set1stMailStepDone: set1stMailStepDone }) })), rechVendorId && ((0, jsx_runtime_1.jsxs)(ModalFooter_1.default, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "inline-flex", alignItems: "center", justifyContent: "flex-end" }, { children: [(0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", onClick: createVendorRel, isSending: isCreating, sx: { mr: 1 } }, { children: "I\u2019ll do this later" })), isOtherVendor && (0, jsx_runtime_1.jsx)(RecharglyButton_1.default, __assign({ onClick: handleOnClose }, { children: "Submit" }))] })), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", onClick: goBack }, { children: "Go Back" }))] }))] })));
};
exports.default = AddVendorModal;
